<template>
  <div class="page-wrapper">
    <div class="poll-details">
      <div class="info">
        <div class="column basic">
          <div class="user-info">
            <basic-info
              :profilePictureURL="baseURL + pollDetails.profilePictureURL"
              :name="pollDetails.authorName"
              :description="pollDetails.divDescription"
            />
          </div>

          <div class="dates">
            <div class="single-date">
              <b>Rok glasanja</b>
              {{ pollDetails.closesAt | formatDateTimeNoSeconds }}
              <br />
              {{ pollDetails.totalVotes }} / {{ pollDetails.maxVotes }}
              {{ getVotesWord }}
            </div>
          </div>
        </div>
        <div class="column right">
          <div class="badges">
            <div style="display: flex">
              <status-badge :status="pollDetails.active"></status-badge>
            </div>
            <div class="btn-wrapper">
              <button
                v-if="pollDetails.active != 'Aktivno'"
                class="btn btn-primary btn--mod"
                title="Štampaj glasanje"
                @click="printPoll"
              >
                <i class="fas fa-file-download" v-if="!loadingPollPdf"></i>
                <spinner
                  :size="20"
                  line-fg-color="#00796b"
                  v-if="loadingPollPdf"
                />
              </button>
              <button @click="openModal" class="btn btn-primary btn--mod">
                <i class="far fa-edit"></i>
              </button>
            </div>
            <!-- <button class="btn btn-medium btn--mod">
              <i v-if="!isTicketInfoExpanded" class="fa fa-expand" aria-hidden="true"></i>
              <i v-if="isTicketInfoExpanded" class="fa fa-compress" aria-hidden="true"></i>
            </button>-->
          </div>
          <div class="description">
            <b>Pitanje</b>
            <p>
              {{ pollDetails.body }}
              <br />
            </p>
          </div>
          <div
            class="files-info"
            v-if="!isPollInfoExpanded && Number(pollDetails.numberOfMedia) > 0"
            @click="isPollInfoExpanded = true"
          >
            <i class="fa fa-paperclip" aria-hidden="true"></i>
            <span
              >{{ pollDetails.numberOfMedia }}
              {{
                Number(pollDetails.numberOfMedia) === 1
                  ? 'fajl'
                  : Number(pollDetails.numberOfMedia) > 4
                  ? 'fajlova'
                  : 'fajla'
              }}</span
            >
          </div>
          <div
            class="files-area"
            v-if="isPollInfoExpanded && Number(pollDetails.numberOfMedia) > 0"
          >
            <a
              class="file"
              v-for="f in pollDetails.medias"
              :href="baseURL + f.link"
              target="_blank"
              :key="f.link"
            >
              <p>{{ f.file_name }}</p>
              <a>
                <i class="fas fa-file-download"></i>
              </a>
            </a>
          </div>
          <!-- <a
            class="show-more-info"
            v-if="!isPollInfoExpanded && (pollDetails.body.length > 200 || Number(pollDetails.numberOfMedia) > 0)"
            @click="isPollInfoExpanded = true"
          >Proširi pregled</a>-->
          <a
            class="show-more-info"
            v-if="isPollInfoExpanded"
            @click="isPollInfoExpanded = false"
            >Sakrij fajlove</a
          >
          <hr style="width: 100%" />
          <div class="poll-stats">
            <div
              class="pie"
              :style="{
                'margin-right': isVotersWrapperExpanded ? '1rem' : 'unset'
              }"
            >
              <pie-chart
                :items="pollDetails.sections"
                :animated="true"
                :shouldShowLegend="!isVotersWrapperExpanded"
                :highlightedOption="pollDetails.votingItemId"
              ></pie-chart>
            </div>
            <div
              class="voters-wrapper"
              v-if="
                basicInfo.active === 'Neaktivno' ||
                  (basicInfo.active === 'Aktivno' && pollDetails.votingItemId)
              "
              :class="{ expanded: isVotersWrapperExpanded }"
              :style="{
                'justify-content':
                  pollDetails.sections.length > 2
                    ? 'space-between'
                    : 'flex-start'
              }"
            >
              <div
                v-for="(section, sectionIndex) of pollDetails.sections"
                :key="section.label"
                class="section"
              >
                <div class="item">
                  <h6>
                    <span
                      class="legend-color"
                      v-if="isVotersWrapperExpanded"
                      :style="{ 'background-color': section.color }"
                    ></span>
                    <b>{{ section.label }}</b>
                  </h6>
                </div>
                <p v-if="!isVotersWrapperExpanded">
                  {{ votesCountForOption(sectionIndex + 1) }}
                </p>

                <template v-if="isVotersWrapperExpanded">
                  <div class="item" v-if="section.percentage === 0">
                    <p>0 glasova</p>
                  </div>
                  <template v-if="section.percentage !== 0">
                    <div
                      v-for="voter of voters"
                      class="item"
                      :key="voter.member_id"
                    >
                      <p v-if="voter.voting_option == sectionIndex + 1">
                        {{ voter.full_name }}
                        ({{
                          Number(voter.voting_points) === 1
                            ? '1 glas'
                            : Number(voter.voting_points) > 4
                            ? voter.voting_points + ' glasova'
                            : voter.voting_points + ' glasa'
                        }})
                      </p>
                    </div>
                  </template>
                </template>
              </div>
            </div>
            <div
              class="voters-wrapper voting-ability"
              v-if="basicInfo.active === 'Aktivno' && !pollDetails.votingItemId"
            >
              <b>Odaberi jednu opciju</b>
              <div id="radio-wrapper">
                <div
                  v-for="section in pollDetails.sections"
                  :key="section.label"
                  class="radio-group"
                >
                  <input
                    type="radio"
                    v-model="managerVotingOptionId"
                    :value="section.id"
                    name="attending"
                    :id="section.id"
                  />
                  <label class="option-label" :for="section.id">{{
                    section.label
                  }}</label>
                  <i class="fas fa-check checkmark-icon"></i>
                </div>
                <button class="btn btn-primary" @click="submitVote">
                  <span v-if="!submitVoteLoaderVisible">Glasaj</span>
                  <spinner v-else :size="20" line-fg-color="#00796b" />
                </button>
              </div>
            </div>
          </div>
          <div
            class="votes-toggle-button"
            v-if="basicInfo.active === 'Neaktivno'"
          >
            <a
              class="show-more-info"
              v-if="!isVotersWrapperExpanded"
              @click="isVotersWrapperExpanded = true"
              >Prikaži glasove</a
            >
            <a
              class="show-more-info"
              v-if="isVotersWrapperExpanded"
              @click="isVotersWrapperExpanded = false"
              >Sakrij glasove</a
            >
          </div>
        </div>
      </div>
      <div class="comments-area">
        <div id="comments" ref="comments">
          <div class="no-comments" v-if="getCommentsNumber === 0">
            <p>Trenutno nema komentara</p>
          </div>
          <comment v-for="c in comments" :comment="c" :key="c.id"></comment>
        </div>
        <div id="new-comment-section">
          <p class="uploaded-file" v-if="attachmentName">
            {{ attachmentName }}
            <span class="btn btn-primary" @click="clearAttachInput">
              <i class="fas fa-times"></i>
            </span>
          </p>
          <div id="upload-area">
            <div
              id="add-img-wrapper"
              @click="uploadFileClicked"
              v-if="!commentUploadUrl"
            >
              <i class="fas fa-paperclip"></i>
            </div>
            <div id="attached-img-wrapper" v-if="commentUploadUrl">
              <div class="hover-shadow" @click="clearAttachInput">
                <i class="far fa-trash-alt"></i>
              </div>
              <img
                :src="commentUploadUrl"
                id="comment-upload-pic"
                alt="slika"
              />
            </div>
          </div>
          <div class="textarea-wrapper">
            <textarea
              class="form-control"
              :class="{ 'textarea-error': comment.length > 300 }"
              @keydown.enter="handleOnEnter"
              :style="{ height: messageTextAreaHeight + 'px' }"
              ref="messageTextArea"
              rows="1"
              placeholder="Unesite komentar"
              v-model="comment"
              @input="autoresizeTextarea"
            ></textarea>
            <div
              class="character-counter"
              :class="{ 'character-counter-error': comment.length > 300 }"
            >
              {{ comment.length }}/300
            </div>
          </div>
          <div id="new-comment-control">
            <input
              @change="fileAttached"
              ref="commentUpload"
              type="file"
              style="display:none"
            />
            <button
              :disabled="comment.length === 0 || commentSending"
              class="btn btn-primary btn--mod"
              @click="submitMedia"
            >
              <slot>
                <spinner
                  :size="20"
                  line-fg-color="#00796b"
                  v-if="commentSending"
                />
              </slot>
              <slot v-if="!commentSending">Pošalji</slot>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicInfo from '@/components/common/BasicInfo.vue';
import Comment from '@/components/common/Comment.vue';
import PieChart from '@/components/post/common/PieChart.vue';
import TicketStatusBadge from '@/components/common/TicketStatusBadge.vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import axios from '@/axios/axios.js';
import { formatDateMixin, formatDateNoSecondsMixin } from '@/mixins/mixins.js';
import { financesInstance } from '@/axios/axios';

export default {
  components: {
    basicInfo: BasicInfo,
    comment: Comment,
    pieChart: PieChart,
    statusBadge: TicketStatusBadge
  },
  created() {
    this.getPollDetails();
  },
  data() {
    return {
      items: [
        { percentage: 20, color: 'red' },
        { percentage: 80, color: 'blue' }
      ],
      baseURL: process.env.VUE_APP_OBJECT_STORAGE_URL,
      comment: '',
      commentUploadUrl: '',
      commentUploadFile: null,
      commentSending: false,
      loadingPollPdf: false,
      isPollInfoExpanded: false,
      isVotersWrapperExpanded: false,
      messageTextAreaHeight: 40,
      managerVotingOptionId: null,
      submitVoteLoaderVisible: false,
      attachmentName: null
    };
  },
  mixins: [formatDateMixin, formatDateNoSecondsMixin],
  computed: {
    ...mapState('poll', ['pollDetails', 'comments', 'voters', 'basicInfo']),
    getCommentsNumber() {
      if (this.comments == null || this.comments.length === 0) {
        return 0;
      } else {
        return 1;
      }
    },
    hasVotes() {
      return this.pollDetails.totalVotes == 0 ? false : true;
    },
    getVotesWord() {
      const word = 'glas';
      let count = this.pollDetails.maxVotes.toString();
      if (
        count.endsWith('11') ||
        count.endsWith('12') ||
        count.endsWith('13') ||
        count.endsWith('14')
      ) {
        return word + 'ova';
      } else {
        if (count.endsWith('1')) {
          return word;
        } else if (
          count.endsWith('2') ||
          count.endsWith('3') ||
          count.endsWith('4')
        ) {
          return word + 'a';
        } else {
          return word + 'ova';
        }
      }
    }
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', ['setPoll', 'showModal']),
    ...mapMutations('poll', ['unsetPoll']),
    ...mapActions('poll', [
      'getPollDetails',
      'getPollComments',
      'getVotingInfo'
    ]),
    ...mapActions('modal', ['showFailModal']),
    votesCountForOption(optionOrder) {
      let count = 0;
      this.voters.forEach(el => {
        if (el.voting_option == optionOrder) {
          count += Number(el.voting_points);
        }
      });
      return count === 1
        ? '1 glas'
        : count > 4 || count === 0
        ? count + ' glasova'
        : count + ' glasa';
    },
    handleOnEnter(e) {
      if (this.commentSending) {
        return;
      }
      if (e.ctrlKey) {
        this.submitMedia();
      }
    },
    autoresizeTextarea(event) {
      event.target.style.height = 'auto';
      event.target.style.height = event.target.scrollHeight + 'px';
      if (event.target.scrollHeight > 110) {
        event.target.style.height = '110px';
      }
    },
    printPoll() {
      this.loadingPollPdf = true;
      financesInstance
        .post(
          `communities/${this.$store.getters.getActiveCommunity.id}/polls/${
            this.basicInfo.pollId
          }/print`,
          {},
          {
            responseType: 'blob'
          }
        )
        .then(({ data }) => {
          var fileURL = window.URL.createObjectURL(new Blob([data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'rezultati_glasanja.pdf');
          document.body.appendChild(fileLink);
          fileLink.click();
          this.loadingPollPdf = false;
        })
        .catch(err => {
          this.showFailModal(
            'Došlo je do neočekivane greške. Molimo pokušajte ponovo.'
          );
          this.loadingPollPdf = false;
          console.log(err);
        });
    },
    openModal() {
      this.setPoll(this.pollDetails);
      this.showModal('ModalContentPollEdit');
    },
    clearAttachInput() {
      this.$refs.commentUpload.value = '';
      this.commentUploadUrl = '';
      this.commentUploadFile = null;
      this.attachmentName = null;
    },
    uploadFileClicked() {
      if (!this.attachmentName) {
        this.$refs.commentUpload.click();
      }
    },
    fileAttached(event) {
      // if (!this.validateInput(event.target.value)) {
      //   this.showFailModal('Fajl mora biti jpg, jpeg ili png');
      //   this.clearAttachInput();
      //   return;
      // }
      // validate file size
      if (event.target.files[0].size > 5122059) {
        this.showFailModal('Fajl ne može biti veći od 5MB');
        return;
      }
      // check if attachment is image
      if (this.validateInput(event.target.value)) {
        this.commentUploadUrl = URL.createObjectURL(event.target.files[0]);
      } else {
        this.attachmentName = event.target.files[0].name;
      }
      this.commentUploadFile = event.target.files[0];
    },
    validateInput(value) {
      let allowedExtensions = ['jpg', 'jpeg', 'png'];
      let extension = value.substring(value.lastIndexOf('.') + 1, value.length);
      return allowedExtensions.indexOf(extension) > -1;
    },
    resetInputFields() {
      this.comment = '';
      this.messageTextAreaHeight = 40;
      this.clearAttachInput();
    },
    formatMediaForSubmit() {
      if (this.commentUploadFile != null) {
        let fd = new FormData();
        fd.append(
          'files[]',
          this.commentUploadFile,
          this.commentUploadFile.name
        );
        fd.append('type', 'community');
        fd.append('community_id', this.$store.getters.getActiveCommunity.id);

        return fd;
      }
      return null;
    },
    submitMedia() {
      if (this.comment.trim() === '') {
        return;
      }
      if (this.comment.trim().length > 300) {
        this.showFailModal('Komentar može imati najviše 300 karaktera.');
        return;
      }
      if (this.commentUploadFile == null) {
        this.commentSending = true;
        this.submitForm();
      } else {
        this.commentSending = true;
        axios
          .post('media/add', this.formatMediaForSubmit(), {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(({ data }) => {
            this.submitForm(data.ids);
          })
          .catch(() => {
            this.commentSending = false;
            this.showFailModal();
          });
      }
    },
    submitForm(mediaData) {
      let postData = {
        body: this.comment.trim(),
        community_id: this.$store.getters.getActiveCommunity.community_id,
        direct_post_receiver_id: 0,
        event: null,
        media_ids: mediaData == null ? '' : mediaData,
        member_id: this.$store.getters.getActiveCommunity.member_id,
        parent_post_id: this.pollDetails.id,
        post_type: 5
      };

      axios
        .post('post', postData)
        .then(res => {
          this.commentSending = false;
          this.getPollComments();
          this.resetInputFields();
        })
        .catch(e => {
          this.commentSending = false;
          console.log(e);
        });
    },
    submitVote() {
      const data = {
        community_id: this.$store.getters.getActiveCommunity.community_id,
        member_id: this.$store.getters.getActiveCommunity.member_id,
        voting_id: this.pollDetails.votingId,
        voting_item_id: this.managerVotingOptionId
      };
      this.submitVoteLoaderVisible = true;
      axios
        .post('post/vote', data)
        .then(res => {
          this.getPollDetails();
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.messages) {
            this.showFailModal(e.response.data.messages);
          }
        })
        .finally(() => {
          this.submitVoteLoaderVisible = false;
        });
    }
  },

  destroyed() {
    this.unsetPoll();
  }
};
</script>

<style scoped lang="scss">
.page-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.character-counter {
  right: 105px;
  bottom: 29px !important;
}

.poll-details {
  // display: flex;
  // min-height: calc(100% - 120px);
  height: calc(100vh - 120px);
  padding: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  &.old {
    display: flex;
  }
}

.info {
  // flex: 20%;
  position: relative;
  border: 1px solid gray;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  .column {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &.basic {
      .user-info {
        display: flex;
        padding-right: 6px;
      }
      .dates {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin: 0;
        margin-top: 20px;
        .single-date {
          // margin-top: 2px;
          display: flex;
          flex-direction: column;
          span {
            margin-top: -4px;
          }
        }
      }
    }
    &.right {
      // border: 1px solid red;
      flex: 3;
      justify-content: flex-start;
      .badges {
        // width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        // margin-top: 5px;
        .statbar {
          margin-right: 3px;
        }
      }
      .description {
        padding: 3px 5px;
        // background-color: #fabb4738;
        /* border: 1px solid #000000; */
        border-radius: 3px;
        p {
          // max-height: 120px;
          overflow: auto;
          margin-top: 4px !important;
          max-height: 118px;
        }
      }
      .files-info {
        border: 1px solid gray;
        border-radius: 6px;
        // width: 140px;
        width: fit-content;
        padding: 4px 8px;
        // padding-left: 10px;
        font-weight: 600;
        display: inline-flex;
        justify-content: center;
        cursor: pointer;
        i {
          font-size: 22px;
          margin-right: 8px;
        }
        &:hover {
          background: rgba(108, 108, 108, 0.05);
        }
      }
      .files-area {
        margin-top: 10px;
        width: 100%;
        text-align: left;
        // max-height: 86px;
        justify-content: space-between;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        resize: none;

        .file {
          display: flex;
          align-items: center;
          // flex-shrink: 0;
          flex: 0 0 49%;
          max-width: 49%;
          background-color: #d5d5d54a;
          margin-bottom: 6px;
          margin-right: 6px;
          height: auto;
          // margin: 4px;
          border-radius: 4px;
          color: black;

          p {
            // word-break: break-word;
            margin-bottom: 0;
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            // direction: rtl;
            padding: 4px;
          }

          i {
            color: var(--primary-color);
            float: right;
            margin: 0 15px;
          }
        }
      }
    }
  }
  .btn--mod {
    // position: absolute;
    // right: 10px;
    // top: 10px;
    flex: 0 0 0;
    // margin-left: auto;
    margin-left: 12px;
    padding: 3px;
    vertical-align: middle;
    height: 35px;
    min-width: 75px;
  }
  .show-more-info {
    margin-top: 8px;
    color: var(--primary-color);
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}

.poll-stats {
  display: flex;
  position: relative;
  // width: 30%;
  .pie {
    // flex: 1;
    max-width: 50%;
  }
  .voters-wrapper {
    display: flex;
    // flex-direction: column;
    flex-wrap: wrap;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    padding-left: 1rem;
    flex: 1;
    justify-content: space-between;

    &.expanded {
      // position: absolute;
      padding-left: 38px;
      /* background: white; */
      height: 18vh;
      overflow: auto;
      /* width: calc(100% - 180px); */
      /* left: 180px; */
      flex-wrap: unset;
    }
    .section {
      // width: 49%;
      max-width: 35%;
      margin-right: 28px;
      .item {
        // margin-bottom: 6px;
        h6 {
          display: flex;

          .legend-color {
            height: 18px;
            width: 18px;
            margin-left: -22px;
            margin-right: 4px;
            border-radius: 2px;
          }
          margin: 6px 0 2px 0;
        }
      }
    }
    &.voting-ability {
      flex-direction: column;
      justify-content: flex-start;
      // align-items: center;
      #radio-wrapper {
        display: flex;
        flex-flow: column;
        align-items: center;
        width: fit-content;
        margin-top: 8px;
        min-width: 14rem;
        max-width: 70%;
        .radio-group {
          // border: solid 1px var(--primary-color);
          border: 1px solid gray;
          margin-top: 0.5rem;
          margin-bottom: 0.5rem;
          border-radius: 10px;
          overflow: hidden;
          position: relative;
          width: 100%;
          display: flex;
        }

        .option-label {
          // color: var(--primary-color);
          color: gray;
          display: inline-block;
          cursor: pointer;
          padding: 5px 30px;
          margin-bottom: 0;
          // width: 14rem;
          text-align: center;
          width: 100%;
          padding: 4px 30px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        input[type='radio'] {
          position: absolute;
          visibility: hidden;
          display: none;
          & ~ .checkmark-icon {
            display: none;
          }
        }

        input[type='radio']:checked + label {
          // color: white;
          // background: var(--primary-color);
          color: black;
          font-weight: 600;
          &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            // background: red;
            opacity: 0.5;
            height: 100%;
            width: 100%;
          }
        }
        input[type='radio']:checked ~ .checkmark-icon {
          display: inline;
          position: absolute;
          right: 8px;
          top: 50%;
          transform: translateY(-50%);
        }
        button {
          width: 100%;
          margin-top: 0.3rem;
          height: 36px;
        }
      }
    }
  }
}

.votes-toggle-button {
  width: 100%;
  text-align: center;
  padding-top: 6px;
  a {
    width: fit-content;
  }
}

.comments-area {
  flex: 80%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  justify-content: space-between;
  #comments {
    overflow: auto;
    padding-right: 10px;
    &.expanded {
      max-height: 54vh;
    }
  }
  #new-comment-section {
    .uploaded-file {
      position: absolute;
      bottom: 60px;
      background: var(--primary-color);
      border-radius: 4px 4px 0 0;
      padding: 0px 8px;
      color: white;
      text-align: left;
      span {
        padding-right: 0;
      }
    }
    // flex: 100px;
    margin-top: 15px;
    height: auto;
    display: inline-flex;
    align-items: flex-end;
    width: 100%;
    textarea {
      resize: none;
    }

    #upload-area {
      // min-width: 40px;
      // max-width: 40px;
      height: 40px;
      width: 45px;
      margin-right: 5px;
      background-color: rgba(211, 211, 211, 0.37);
      border-radius: 5px;
      overflow: hidden;

      #attached-img-wrapper {
        .hover-shadow {
          border-radius: 5px;
          opacity: 0;
          min-width: 40px;
          min-height: 40px;
          background-color: rgba(0, 0, 0, 0.41);
          position: absolute;
          transition: opacity 0.2s;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            color: white;
          }
        }
      }

      #attached-img-wrapper:hover {
        .hover-shadow {
          opacity: 1;
        }
      }

      #add-img-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .fa-paperclip {
        transition: color 0.25s;
        font-size: 25px;
      }

      img {
        width: 40px;
        height: 40px;
        object-fit: scale-down;
      }
    }

    #upload-area:hover {
      cursor: pointer;
      .fa-paperclip {
        color: var(--primary-color);
      }
    }

    #new-comment-control {
      display: flex;
      float: right;
      align-items: flex-end;

      button {
        margin-left: 5px;
        height: 40px;
        // width: 40px;
        i {
          font-size: 35px;
        }
      }

      #comment-upload-btn {
        margin-right: 5px;
        font-size: 20px;
      }
    }
  }
}

.poll-info {
  width: 30%;
  min-width: 300px;
  /*position: relative;*/
  display: flex;
  flex-grow: 1;
  flex-shrink: 4;
  flex-direction: column;
}
// .comments-area {
//   width: 50%;
//   margin: 0 15px;
//   flex-shrink: 1;
//   flex-grow: 4;
// }

// #comments {
//   overflow-y: auto;
//   height: calc(100% - 180px);
//   max-height: calc(100% - 180px);
//   padding: 0 15px;
//   border-left: 1px solid rgba(108, 108, 108, 0.55);
//   border-right: 1px solid rgba(108, 108, 108, 0.55);
// }

.section-title {
  text-align: center;
  margin-bottom: 40px;
  h5 {
    display: inline-block;
    padding-bottom: 5px;
    border-bottom: 2px solid var(--primary-color);
  }
}

.user-info {
  display: flex;
}

.btn-wrapper {
  margin-left: auto;
}

.btn--mod {
  margin-left: 10px;
  padding: 3px;
  height: 35px;
  min-width: 55px;
}

.btn--mod:focus {
  outline: none;
  box-shadow: none;
}

.primary {
  color: var(--primray-color);
}

.no-comments {
  // text-align: center;
  // margin-top: 30px;
}

// #new-comment-section {
//   margin-top: 15px;
//   height: auto;
//   display: inline-flex;
//   width: 100%;
//   textarea {
//     resize: none;
//   }

//   #upload-area {
//     min-width: 85px;
//     max-width: 85px;
//     margin-right: 5px;
//     background-color: rgba(211, 211, 211, 0.37);
//     border-radius: 5px;
//     overflow: hidden;

//     #attached-img-wrapper {
//       .hover-shadow {
//         border-radius: 5px;
//         opacity: 0;
//         min-width: 85px;
//         min-height: 85px;
//         background-color: rgba(0, 0, 0, 0.41);
//         position: absolute;
//         transition: opacity 0.2s;
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         i {
//           color: white;
//         }
//       }
//     }

//     #attached-img-wrapper:hover {
//       .hover-shadow {
//         opacity: 1;
//       }
//     }

//     #add-img-wrapper {
//       width: 100%;
//       height: 100%;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }

//     .fa-paperclip {
//       transition: color 0.25s;
//       font-size: 25px;
//     }

//     img {
//       width: 85px;
//       height: 85px;
//       object-fit: cover;
//     }
//   }

//   #upload-area:hover {
//     cursor: pointer;
//     .fa-paperclip {
//       color: var(--primary-color);
//     }
//   }

//   #new-comment-control {
//     display: flex;
//     float: right;
//     align-items: center;

//     button {
//       margin-left: 5px;
//     }

//     #comment-upload-btn {
//       margin-right: 5px;
//       font-size: 20px;
//     }
//   }
// }
// .voters-wrapper {
//   margin-top: 30px;
//   max-height: calc(100% - 340px);
//   overflow-y: auto;
// }

// .dates {
//   display: flex;
//   flex-direction: column;
//   text-align: left;
//   margin-bottom: 25px;
//   p {
//     margin-bottom: 5px;
//   }
// }

// .badges {
//   display: flex;
//   align-content: flex-start;
//   margin: 5px 0 15px 0;
//   .statbar {
//     margin-right: 3px;
//   }
// }

// .files-area {
//   width: 100%;
//   text-align: left;
//   max-height: 60%;
//   justify-content: space-between;
//   overflow-y: auto;
//   display: flex;
//   flex-direction: column;
//   resize: none;
// }

// .file {
//   display: flex;
//   align-items: center;
//   flex-shrink: 0;
//   background-color: #d5d5d54a;
//   margin-bottom: 1px;
//   height: auto;

//   p {
//     word-break: break-word;
//     margin-bottom: 0;
//     width: 100%;
//   }

//   i {
//     color: var(--primary-color);
//     float: right;
//     margin: 0 15px;
//   }
// }
</style>
